import { Pipe, PipeTransform, TemplateRef } from '@angular/core';

const CONST_STATUS = {
  ERROR: 'error',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
};

@Pipe({
  name: 'cardImage',
  standalone: true,
  pure: true,
})
export class CardImagePipe implements PipeTransform {
  transform(
    status: string,
    errorCardImage: TemplateRef<unknown>,
    processingCardImage: TemplateRef<unknown>,
    completedCardImage: TemplateRef<unknown>,
  ): TemplateRef<unknown> {
    const imageMap: Record<string, TemplateRef<unknown>> = {
      [CONST_STATUS.ERROR]: errorCardImage,
      [CONST_STATUS.PROCESSING]: processingCardImage,
      [CONST_STATUS.COMPLETED]: completedCardImage,
    };
    return imageMap[status] ?? errorCardImage;
  }
}
